<template>
    <Button v-if="!beingTranslated" class="button-default flex align-items-center gap-2" @click="translateTo"
        :class="buttonClass">
        <i class="pi pi-language"></i>
        <span class="ml-auto">{{ $t('form.translate') }}</span>
        <Avatar :image="getFlag(locale === 'fr' ? 'en' : 'fr')" shape="square" class="ml-auto"
            style="width: 35px; height: 25px; background-color: white; padding: 3px;" />
    </Button>
    <ProgressSpinner v-else strokeWidth="5" style="width: 30px; height: 30px;" />
</template>

<script>
import Button from 'primevue/button';
import Avatar from 'primevue/avatar';
import ProgressSpinner from 'primevue/progressspinner';
import { translate } from '@/services/googleTranslateService';

export default {
    name: 'TranslateButton',
    components: {
        Button,
        Avatar,
        ProgressSpinner
    },
    props: {
        buttonClass: {
            type: String,
            default: ''
        },
        stringsToTranslate: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            beingTranslated: false
        }
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        }
    },
    emits: ['onTranslationSuccess'],
    methods: {
        getFlag(iso) {
            if (!iso) return '';
            try {
                return new URL(`../../assets/images/flags/${iso.toLowerCase()}.svg`, import.meta.url).href;
            } catch (e) {
                return '';
            }
        },
        async translateTo() {
            this.beingTranslated = true;

            try {
                const targetTranslate = this.locale === 'fr' ? 'en' : 'fr';
                const translatedData = await translate(this.stringsToTranslate, targetTranslate);

                if (Array.isArray(translatedData) && translatedData.length === this.stringsToTranslate.length) {
                    this.$emit('onTranslationSuccess', translatedData, targetTranslate);
                }
            } catch (error) {
                console.error("Translation error:", error);
            } finally {
                this.beingTranslated = false;
            }
        }
    }
}
</script>
